import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
	template: '',
})
export class CopRedirectComponent implements OnInit {
	
	constructor() { }
	
	ngOnInit() {
		window.location.replace(environment.copBaseURL);
	}
	
}
